export default __webpack_public_path__ + "static/media/RFP.506b7a2a.png";